module.exports = __webpack_public_path__ + "img/dagopt.5bfebfc5.png";